export function getdata() {
	let obj = {
		searchlist: [{
				prop: "groupName",
				label: '账套名称',
				type: "input",
			},
			{
				prop: "qiymc",
				label: '创建公司',
				type: "input",
			},
			{
				prop: "creator",
				label: '创建人',
				type: "input",
			}, {
				prop: "createTime",
				label: '创建时间',
				type: "input",
			}, {
				prop: "refs",
				label: '引用公司',
				type: "input",
			}, {
				prop: "description",
				label: '账套描述',
				type: "input",
			},
		],
		searchdata: {
			groupName: '',
			qiymc: '',
			creator: '',
			createTime: '',
			refs: '',
			description: '',
		},
		headData: [{
				title: "账套名称",
				prop: "groupName",
				width: "150"
			},
			{
				title: "创建公司",
				prop: "qiymc",
				width: "150"
			},
			{
				title: "创建人",
				prop: "creator",
				width: "150"
			},
			{
				title: "创建时间",
				prop: "createTime",
				width: "150"
			},
			{
				title: "引用公司",
				prop: "refs",
				width: "150"
			},
			{
				title: "账套描述",
				prop: "description",
				width: "150"
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
